import type { AxiosError } from 'axios';
import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import * as collectionsApi from '@hotjar/webapp/domains/collections/api';
import { queryClient } from '@hotjar/webapp/utils/react-query';

type ApiFunction = typeof collectionsApi.rename;
type ApiResponseType = Awaited<ReturnType<ApiFunction>>;

export function useCollectionRename(
  siteId: Parameters<ApiFunction>[0],
  collectionId: Parameters<ApiFunction>[1],
): UseMutationResult<ApiResponseType, AxiosError, { name: Parameters<ApiFunction>[2] }> {
  return useMutation(({ name }) => collectionsApi.rename(siteId, collectionId, name), {
    onSuccess() {
      queryClient.invalidateQueries(collectionsApi.COLLECTIONS_LIST_QUERY_KEY);
    },
  });
}

export { ExistingCollectionError } from '@hotjar/webapp/domains/collections/api';
